/**
 * デジタルサイネージ用モジュール
 *
 * @module app/signage/display/SignageWeatherInfoStatusPage
 */
define(['module',
    'dojo',
    'dojo/_base/array',
    'dojo/_base/declare',
    'dojo/_base/lang',
    'dojo/dom-class',
    'dojo/dom-construct',
    'dojo/dom-style',
    'dojo/text!./templates/SignageWeatherInfoStatusPage.html',
    'idis/service/Requester',
    'idis/view/Loader',
    '../_SignageBase',
    'idis/map/IdisMap',
    'app/model/LayerStore',
    'idis/control/Locator',
    'app/config',
    'idis/consts/QUERY',
    'app/util/AreaUtil',
    //'../../config',
    // 以下、変数で受けないモジュール
    'dijit/Dialog',
    'dijit/form/Form',
    'dijit/layout/BorderContainer',
    'dijit/layout/ContentPane',
    'idis/view/form/AclButton',
], function (module, dojo, array, declare, lang, domClass, domConstruct, domStyle, template, Requester, Loader, _SignageBase, IdisMap, LayerStore, Locator, config, QUERY, AreaUtil) {

    // 前回表示データ
    // セッションストレージ等に保持するほうが良いか？
    var prevItemStore = {};
    var prevWeatherItemStore = {};

    // 新着情報判定フラグ
    var updateColumnFlg = false;

    /**
     *
     * @class SignageWeatherInfoStatusPage
     * @extends module:idis/view/page/_PageBase~_PageBase
     */
    return declare(module.id.replace(/\//g, '.'), _SignageBase,
        /** @lends module:app/signage/display/SignageWeatherInfoStatusPage~SignageWeatherInfoStatusPage# */
        {
            // テンプレート文字列
            templateString: template,

            _timer: null,

            // ページ切替間隔時間（秒）
            SIGNAGE_UPDATE_INTERVAL: 10,

            // レイヤーID
            _layerId: [],

            // 緯度経度
            _latlng: null,

            // ズーム
            _zoom: null,

            _layerControl: null,

            // 表示ページ
            _page: 0,

            // ページあたり表示件数
            PAGE_LIST_SIZE: 15,

            // 値を表示する項目のリスト
            target: [
                { 'item': 'designatedRiver', 'area': 'designatedRiverArea' },
                { 'item': 'earthquake', 'area': 'earthquakeArea' },
                { 'item': 'tsunami', 'area': 'tsunamiArea' }
            ],

            // ルート要素に付与されるCSS
            baseClass: 'idis-Page idis-Page--signage',

            constructor: function () {
                this.inherited(arguments);
            },

            buildRendering: function () {
                this.inherited(arguments);
            },

            startup: function () {
                this.inherited(arguments);
                this.initPage();
            },

            destroy: function () {
                this.inherited(arguments);
                clearTimeout(this._timer);
            },

            /**
             * 画面表示
             */
            initPage: function () {
                Requester.get('/api/signage/' + this._screenId).then(lang.hitch(this, function (data) {
                    var item = data;
                    this._version = item.version;
                    // レイヤー
                    this._layerId = item.layerId;
                    // 緯度経度
                    if (item.latitude && item.longitude) {
                        this._latlng = [item.latitude, item.longitude];
                    } else {
                        this._latlng = [config.map.latitude, config.map.longitude];
                    }
                    // ズーム
                    if (item.zoom) {
                        this._zoom = item.zoom;
                    } else {
                        this._zoom = 9;
                    }

                    // マップを初期化
                    this.initMap();

                    // 行政界レイヤーを表示
                    this.putFirstLayer();

                    // レイヤーを表示
                    this.showLayer();

                    // 凡例を表示
                    //this.showLegend();

                }), function (error) {
                    // 処理失敗時はエラーログを出力し、エラーダイアログを表示
                    console.error(error);
                    this.chain.infoError(error);
                });

                this.setWeatherInfoStatus();

                // 一覧表を設定
                this.setGrid();
            },

            /**
             * 気象情報を設定します
             */
            setWeatherInfoStatus: function () {
                var promise = Requester.get('/data/signage/' + this._screenId + '.json', {
                    headers: { 'Content-Type': 'application/json; charset=utf-8' },
                    handleAs: 'json',
                    preventCache: true
                }).then(lang.hitch(this, function (item) {
                    // 気象情報（画面上部エリア）を設定
                    var weatherInfoOverview = item.items[0];
                    this.setWeatherInfoOverview(this, weatherInfoOverview);

                    // 前回データを更新
                    prevItemStore[this._screenId] = item;

                }), function (error) {
                    if (error.response.status === 404) {
                        var weatherInfoOverview = {};
                        this.setWeatherInfoOverview(this, weatherInfoOverview);
                    } else {
                        this.chain.info('情報の取得に失敗しました。', 'エラー');
                    }
                });
                //ローダーの表示
                Loader.wait(promise);
            },

            /**
             * 画面上部エリアを設定します
             */
            setWeatherInfoOverview: function (self, item) {

                // 項目に取得した値を設定/発令状況による背景色・文字色変更

                // 指定河川
                // R7気象改修によるコメントアウト↓
                // var dispStringRiver = '発表なし';
                // var addStyleRiver = 'fs-2';
                // if (item.designatedRiver === '10') {
                //     dispStringRiver = '解除';
                //     addStyleRiver = 'river-level-1 fs-2';
                // } else if (item.designatedRiver.charAt(0) === '2') {
                //     dispStringRiver = '氾濫注意情報';
                //     addStyleRiver = 'river-level-2 fs-4';
                // } else if (item.designatedRiver.charAt(0) === '3') {
                //     dispStringRiver = '氾濫警戒情報';
                //     addStyleRiver = 'river-level-3 fs-4';
                // } else if (item.designatedRiver.charAt(0) === '4') {
                //     dispStringRiver = '氾濫危険情報';
                //     addStyleRiver = 'river-level-4 fs-4';
                // } else if (item.designatedRiver.charAt(0) === '5') {
                //     dispStringRiver = '氾濫発生情報';
                //     addStyleRiver = 'river-level-5 fs-4';
                // }
                // self.designatedRiver.innerHTML = dispStringRiver;
                // domClass.add(this.designatedRiverArea, addStyleRiver);

                // 地震
                var dispStringEarthquake = '発表なし';
                var addStyleEarthquake = '';

                if (item.earthquake) {
                    dispStringEarthquake = item.earthquake;
                    addStyleEarthquake = 'earthquake-warning';
                }
                self.earthquake.innerHTML = dispStringEarthquake;
                domClass.add(this.earthquakeArea, addStyleEarthquake);

                // 津波
                var dispStringTsunami = '発表なし';
                var addStyleTsunami = 'fs-2';
                switch (item.tsunami) {
                    case '52':
                    case '53':
                        dispStringTsunami = '大津波警報';
                        addStyleTsunami = 'oo-tsunami-warning fs-3';
                        break;
                    case '51':
                        dispStringTsunami = '津波警報';
                        addStyleTsunami = 'tsunami-warning fs-2';
                        break;
                    case '62':
                        dispStringTsunami = '津波注意報';
                        addStyleTsunami = 'tsunami-advisory fs-3';
                        break;
                }
                self.tsunami.innerHTML = dispStringTsunami;
                domClass.add(this.tsunamiArea, addStyleTsunami);

                // 更新状態を設定
                this.setWeatherInfoOverviewUpdate(self, item);
            },

            /**
             * 画面上部エリアの更新状態を設定します
             */
            setWeatherInfoOverviewUpdate: function (self, item) {
                var updateFlg = false;
                // 前回データがある場合のみ処理
                // 前回データがない場合（≒初回表示）は処理しない
                var prevItem = prevItemStore[this._screenId];
                if (!prevItem) {
                    return;
                }
                var weatherInfoOverview = prevItem.items[0];
                if (weatherInfoOverview) {
                    array.forEach(this.target, function (target) {
                        // 更新された項目にstyleを設定
                        if (weatherInfoOverview[target.item] !== item[target.item]) {
                            domClass.add(self[target.area], 'update-column');
                            updateFlg = true;
                        } else {
                            domClass.remove(self[target.area], 'update-column');
                        }
                    });
                }
                // 更新された項目がある場合、通知音を鳴らす
                if (updateFlg) {
                    this.playAudio();
                }
            },

            /**
             * 最新の市町村別気象注警報を一覧設定します
             */
            setGrid: function () {
                var self = this;

                var promise = Requester.get('/data/weather/weatherWarning.json', {
                    headers: { 'Content-Type': 'application/json; charset=utf-8' },
                    handleAs: 'json',
                    preventCache: true
                }).response.then(function (response) {
                    // 政令指定都市は除外する
                    var filtered = array.filter(response.data.items, function (item) {
                        return !AreaUtil.isOrdinanceDesignatedCity(item.municipalityCd);
                    });

                    // 最新の市町村別気象注警報・土砂災害発表状況を設定
                    self.setJson(self, filtered);
                    // グリッド内の前回データを更新
                    prevWeatherItemStore = filtered;

                }, function (error) {
                    if (error.response.status === 404) {
                        console.log('最新の市町村別気象注警報が見つかりません。初期値をセットします。' + (error.message ? ('(' + error.message + ')') : ''));
                        self.setJson(self, []);
                    } else {
                        self.chain.info('情報の取得に失敗しました。', 'エラー');
                    }
                });
                //ローダーの表示
                Loader.wait(promise);
            },

            initMap: function () {
                // マップの初期化
                this.map = new IdisMap(this.id + '-map', {
                    config: config.map,
                    keyboard: false, // コメント時に+/-が使用できないため
                    touchExtend: false, // IE対応
                    minZoom: 9,
                    maxZoom: 18,
                    drawControlTooltips: false
                }).setView(this._latlng, this._zoom);

                // mapのdestroyはremoveでDojoと互換なのでownで消せる
                this.own(this.map);

                this._layerControl = this.map.layerControl;

            },

            /**
             * 最新の市町村別気象注警報・土砂災害発表状況を設定します
             */
            setJson: function (self, items) {
                const total = items.length;
                // HTML上の一覧ID
                var weatherInfoStatusTBody = dojo.byId('weatherInfoStatusTBody');
                domConstruct.empty(weatherInfoStatusTBody);

                // 表示対象ページの抽出
                // 開始インデックス
                var firstIndex = this.PAGE_LIST_SIZE * this._page;
                // 終了インデックス
                var lastIndex = this.PAGE_LIST_SIZE * (this._page + 1) - 1;
                // 表示範囲
                var displayData = items.filter((element, index) =>
                    index >= firstIndex && index <= lastIndex
                );

                // 画面上のページ数表示
                // 現在ページ番号
                if (items.length <= this.PAGE_LIST_SIZE) {
                    domStyle.set(this.pageArea, 'display', 'none');
                } else {
                    self.currentPage.innerHTML = this._page + 1;
                    // 全数ページ番号
                    self.totalPage.innerHTML = Math.ceil(total / this.PAGE_LIST_SIZE);
                }

                updateColumnFlg = false;

                // 表示範囲のデータに対して繰り返す
                array.forEach(displayData, function (item) {

                    var classMunicipality = ' p-1 align-middle text-center fw-bold';
                    var styleMunicipality = 'width:10%; background-color:#EEEEEE;';

                    // 行オブジェクト
                    var tr = domConstruct.create('tr');

                    // 気象エリア
                    domConstruct.place(domConstruct.create(
                        'td',
                        {
                            innerHTML: item.areaName,
                            class: classMunicipality,
                            style: styleMunicipality
                        }
                    ), tr);

                    // 各市町村毎のセル(TD)を追加
                    self.setTd(self, item, tr);

                    // 作成した一覧をHTML上の一覧IDにセット
                    domConstruct.place(tr, weatherInfoStatusTBody);
                });

                // 次回表示ページ
                if (lastIndex >= total - 1) {
                    // 先頭ページ
                    this._page = 0;
                } else {
                    // 次ページ
                    this._page += 1;
                }

                // 更新された項目がある場合、通知音を鳴らす
                if (updateColumnFlg) {
                    this.playAudio();
                }

                // 定期更新処理
                this._timer = setTimeout(lang.hitch(this, function () {
                    self.setJson(self, items);
                }), this.SIGNAGE_UPDATE_INTERVAL * 1000);
            },

            /**
             * 一覧の行に画面のセル(TD)をセットする。
             * 
             * @param self 
             * @param item JSON内容
             * @param tr 行(TR)オブジェクト
             * @returns 無し
             */
            setTd: function (self, item, tr) {

                // 氾濫該当項目
                // F5 : レベル５氾濫特別警報
                // F4 : レベル４氾濫危険警報
                // F3 : レベル３氾濫警報
                // F2 : レベル２氾濫注意報
                var sedimentArr = ["F5","F4", "F3", "F2"];
                domConstruct.place(self.getTdObject(self, item, sedimentArr), tr);

                // 大雨該当項目(警戒レベル降順)
                // 33 : レベル５大雨特別警報
                // 43 : レベル４大雨危険警報
                // 03 : レベル３大雨警報
                // 10 : レベル２大雨注意報
                var heavyRaincdArr = ["33", "03", "10","43"];
                domConstruct.place(self.getTdObject(self, item, heavyRaincdArr), tr);

                // 土砂該当項目(警戒レベル降順)
                // 39 : レベル５土砂災害特別警報
                // 49 : レベル４土砂災害危険警報
                // 09 : レベル３土砂災害警報
                // 29 : レベル２土砂災害注意報
                var floodArr = ["39", "49", "09", "29"];
                domConstruct.place(self.getTdObject(self, item, floodArr), tr);

                // 高潮該当項目(警戒レベル降順)
                // 38 : レベル５高潮特別警報
                // 48 : レベル４高潮危険警報
                // 08 : レベル３高潮警報
                // 19 : レベル２高潮注意
                var highTideArr = ["38", "08", "19", "48"];
                domConstruct.place(self.getTdObject(self, item, highTideArr), tr);

                // 暴風該当項目(警戒レベル降順)
                // 35 : 【警戒レベル5相当】暴風特別警報
                // 05 : 【警戒レベル3相当】暴風警報
                // 15 : 【警戒レベル2相当】強風注意報
                var stormArr = ["35", "05", "15"];
                domConstruct.place(self.getTdObject(self, item, stormArr), tr);

                // 暴風雪該当項目(警戒レベル降順)
                // 32 : 【警戒レベル5相当】暴風雪特別警報
                // 02 : 【警戒レベル3相当】暴風雪警報
                // 13 : 【警戒レベル2相当】風雪注意報
                var blizardArr = ["32", "02", "13"];
                domConstruct.place(self.getTdObject(self, item, blizardArr), tr);

                // 大雪該当項目(警戒レベル降順)
                // 36 : 【警戒レベル5相当】大雪特別警報
                // 06 : 【警戒レベル3相当】大雪警報
                // 12 : 【警戒レベル2相当】大雪注意報
                var heavySnoueArr = ["36", "06", "12"];
                domConstruct.place(self.getTdObject(self, item, heavySnoueArr), tr);

                // 波浪該当項目(警戒レベル降順)
                // 37 : 【警戒レベル5相当】波浪特別警報
                // 07 : 【警戒レベル3相当】波浪警報
                // 16 : 【警戒レベル2相当】波浪注意報
                var wavesArr = ["37", "07", "16"];
                domConstruct.place(self.getTdObject(self, item, wavesArr), tr);

                // 雷該当項目(警戒レベル降順)
                // 14 : 【警戒レベル2相当】雷注意報
                var thunderArr = ["14"];
                domConstruct.place(self.getTdObject(self, item, thunderArr), tr);

                // 濃霧該当項目(警戒レベル降順)
                // 20 : 【警戒レベル2相当】濃霧注意報
                var denseFogArr = ["20"];
                domConstruct.place(self.getTdObject(self, item, denseFogArr), tr);

                // 乾燥該当項目(警戒レベル降順)
                // 21 : 【警戒レベル2相当】乾燥注意報
                var dryArr = ["21"];
                domConstruct.place(self.getTdObject(self, item, dryArr), tr);

                return;

            },

            /**
             * JSON１行毎に、画面のセルに該当する気象情報種別に該当する気象情報種別があるか判定し、
             * ある場合は災害レベルに応じたセル(TD)オブジェクトを返す。
             * 無い場合は真白なセル(TD)オブジェクトを返す。
             * 
             * @param self 
             * @param item JSON内容
             * @param cdArr 画面のセル(土砂、大雨etc)に該当する気象情報種別の配列
             * @returns セル(TD)オブジェクト
             */
            getTdObject(self, item, cdArr) {
                // テキスト
                var text = "";
                // 背景色
                var bgcolor = '#FFFFFF';
                // 文字色
                var fontcolor = '#000000';
                // CSS定義
                var newArrivalCss = "";

                var className = '';

                // 市町村の気象情報の前回値
                var prevWeatherList = null;
                if (prevWeatherItemStore && prevWeatherItemStore.length > 0) {
                    prevWeatherList = prevWeatherItemStore.filter((element) =>
                        element.areaCode === item.areaCode
                    )[0];
                    // 新規のデータが追加された場合は前回値を0として設定
                    if (prevWeatherList === undefined) {
                        prevWeatherList = { 'name': '', 'count': 0 };
                    }
                }

                // ここで配列の中身が前と同じかどうかをチェっく。異なっていた場合はどこが変わっているのかを出す。

                // 気象情報種別の配列(警戒レベル降順)の件数分繰り返す
                // 該当がある場合、ループを抜ける
                cdArr.some(function (cd) {

                    // 気象情報種別
                    var val = item[cd];

                    // 気象情報種別が存在する場合
                    if (undefined !== val) {
                        // セルの設定情報を取得
                        let tdInfo = self.getTdInfo(cd, val);

                        // valの値と、配列の中民も値を比べて等しい場合はupdate-columnを付け加える
                        className = prevWeatherList && (prevWeatherList[cd] !== val) ? ' update-column' : '';
                        if (className) { updateColumnFlg = true; }

                        // テキスト
                        text = tdInfo.text;
                        // 背景色
                        bgcolor = tdInfo.bgColor;
                        // 文字色
                        fontcolor = tdInfo.fontColor;
                        // 新着情報CSS定義
                        newArrivalCss = tdInfo.newArrivalCss + className;

                        // ループを抜ける
                        return true;
                    }
                });

                // class定義
                var classContent = ' p-1 align-middle text-center' + newArrivalCss;
                // style定義
                var styleContent = 'background-color: ' + bgcolor + '; color: ' + fontcolor + ';';

                // セルオブジェクトを作成する
                var tdObj = domConstruct.create(
                    'td',
                    {
                        innerHTML: text,
                        class: classContent,
                        style: styleContent
                    }
                );

                return tdObj;
            },

            /**
             * 気象情報種別毎のセル(TD)の設定情報を取得する
             * 
             * @param cd 気象情報種別
             * @param val 気象情報種別の値
             * @returns セル(TD)の設定情報
             */
            getTdInfo: function (cd, val) {

                // テキスト
                // 特別警報
                const LEVEL5_TEXT = "特";
                const LEVEL5_BGCOLOR = "#000000";
                const LEVEL5_FONTCOLOR = "#FFFFFF";
                // 危険警報
                const LEVEL4_TEXT = "危";
                const LEVEL4_BGCOLOR = "#C800FF";
                const LEVEL4_FONTCOLOR = "#FFFFFF";
                // 警報
                const LEVEL3_TEXT = "警";
                const LEVEL3_BGCOLOR = "#FF0000";
                const LEVEL3_FONTCOLOR = "#FFFFFF";
                // 注意報
                const LEVEL2_TEXT = "注";
                const LEVEL2_BGCOLOR = "#FFFF00";
                const LEVEL2_FONTCOLOR = "#000000";
                // 解除
                const CANCEL_TEXT = "解";
                const CANCEL_BGCOLOR = "#FFFFFF";
                const CANCEL_FONTCOLOR = "#000000";
                // 該当無し
                const DEFAULT_TEXT = "";
                const DEFAULT_BGCOLOR = "#FFFFFF";
                const DEFAULT_FONTCOLOR = "#000000";

                // テキスト
                var text = DEFAULT_TEXT;
                // 背景色
                var bgColor = DEFAULT_BGCOLOR;
                // 文字色
                var fontColor = DEFAULT_FONTCOLOR;
                // 新着情報CSS定義
                var newArrivalCss = "";

                // 気象情報種別毎のセルにセットする情報を判定する
                switch (cd) {
                    // 暴風雪警報
                    case "02":
                        text = LEVEL3_TEXT;
                        bgColor = LEVEL3_BGCOLOR;
                        fontColor = LEVEL3_FONTCOLOR;
                        break;
                    // 氾濫警報
                    case "F3":
                        text = LEVEL3_TEXT;
                        bgColor = LEVEL3_BGCOLOR;
                        fontColor = LEVEL3_FONTCOLOR;
                        break;
                    // 大雨警報
                    case "03":
                        text = LEVEL3_TEXT;
                        bgColor = LEVEL3_BGCOLOR;
                        fontColor = LEVEL3_FONTCOLOR;
                        break;
                    // 土砂災害警報
                    case "09":
                        text = LEVEL3_TEXT;
                        bgColor = LEVEL3_BGCOLOR;
                        fontColor = LEVEL3_FONTCOLOR;
                        break;
                    // 暴風警報
                    case "05":
                        text = LEVEL3_TEXT;
                        bgColor = LEVEL3_BGCOLOR;
                        fontColor = LEVEL3_FONTCOLOR;
                        break;
                    // 大雪警報
                    case "06":
                        text = LEVEL3_TEXT;
                        bgColor = LEVEL3_BGCOLOR;
                        fontColor = LEVEL3_FONTCOLOR;
                        break;
                    // 波浪警報
                    case "07":
                        text = LEVEL3_TEXT;
                        bgColor = LEVEL3_BGCOLOR;
                        fontColor = LEVEL3_FONTCOLOR;
                        break;
                    // 高潮警報
                    case "08":
                        text = LEVEL3_TEXT;
                        bgColor = LEVEL3_BGCOLOR;
                        fontColor = LEVEL3_FONTCOLOR;
                        break;
                    // 氾濫注意報
                    case "F2":
                        text = LEVEL2_TEXT;
                        bgColor = LEVEL2_BGCOLOR;
                        fontColor = LEVEL2_FONTCOLOR;
                        break;
                    // 大雨注意報
                    case "10":
                        text = LEVEL2_TEXT;
                        bgColor = LEVEL2_BGCOLOR;
                        fontColor = LEVEL2_FONTCOLOR;
                        break;
                    // 土砂災害注意報
                    case "29":
                        text = LEVEL2_TEXT;
                        bgColor = LEVEL2_BGCOLOR;
                        fontColor = LEVEL2_FONTCOLOR;
                        break;
                    // 大雪注意報
                    case "12":
                        text = LEVEL2_TEXT;
                        bgColor = LEVEL2_BGCOLOR;
                        fontColor = LEVEL2_FONTCOLOR;
                        break;
                    // 風雪注意報
                    case "13":
                        text      = LEVEL2_TEXT;
                        bgColor   = LEVEL2_BGCOLOR;
                        fontColor = LEVEL2_FONTCOLOR;
                        break;
                    // 雷注意報
                    case "14":
                        text = LEVEL2_TEXT;
                        bgColor = LEVEL2_BGCOLOR;
                        fontColor = LEVEL2_FONTCOLOR;
                        break;
                    // 強風注意報
                    case "15":
                        text = LEVEL2_TEXT;
                        bgColor = LEVEL2_BGCOLOR;
                        fontColor = LEVEL2_FONTCOLOR;
                        break;
                    // 波浪注意報
                    case "16":
                        text = LEVEL2_TEXT;
                        bgColor = LEVEL2_BGCOLOR;
                        fontColor = LEVEL2_FONTCOLOR;
                        break;
                    // 融雪注意報
                    case "17":
                        // 本画面では該当無し
                        // text      = LEVEL_TEXT;
                        // bgColor   = LEVEL_BGCOLOR;
                        // fontColor = LEVEL_FONTCOLOR;
                        break;
                    // 高潮注意報
                    case "19":
                        text = LEVEL2_TEXT;
                        bgColor = LEVEL2_BGCOLOR;
                        fontColor = LEVEL2_FONTCOLOR;
                        break;
                    // 濃霧注意報
                    case "20":
                        text = LEVEL2_TEXT;
                        bgColor = LEVEL2_BGCOLOR;
                        fontColor = LEVEL2_FONTCOLOR;
                        break;
                    // 乾燥注意報
                    case "21":
                        text = LEVEL2_TEXT;
                        bgColor = LEVEL2_BGCOLOR;
                        fontColor = LEVEL2_FONTCOLOR;
                        break;
                    // なだれ注意報
                    case "22":
                        // 本画面では該当無し
                        // text      = LEVEL_TEXT;
                        // bgColor   = LEVEL_BGCOLOR;
                        // fontColor = LEVEL_FONTCOLOR;
                        break;
                    // 低温注注意報
                    case "23":
                        // 本画面では該当無し
                        // text      = LEVEL_TEXT;
                        // bgColor   = LEVEL_BGCOLOR;
                        // fontColor = LEVEL_FONTCOLOR;
                        break;
                    // 霜注意報
                    case "24":
                        // 本画面では該当無し
                        // text      = LEVEL_TEXT;
                        // bgColor   = LEVEL_BGCOLOR;
                        // fontColor = LEVEL_FONTCOLOR;
                        break;
                    // 着氷注意報
                    case "25":
                        // 本画面では該当無し
                        // text      = LEVEL_TEXT;
                        // bgColor   = LEVEL_BGCOLOR;
                        // fontColor = LEVEL_FONTCOLOR;
                        break;
                    // 着雪注意報
                    case "26":
                        // 本画面では該当無し
                        // text      = LEVEL_TEXT;
                        // bgColor   = LEVEL_BGCOLOR;
                        // fontColor = LEVEL_FONTCOLOR;
                        break;
                    // その他の注意報
                    case "27":
                        // 本画面では該当無し
                        // text      = LEVEL_TEXT;
                        // bgColor   = LEVEL_BGCOLOR;
                        // fontColor = LEVEL_FONTCOLOR;
                        break;
                    // 暴風雪特別警報
                    case "32":
                        text = LEVEL5_TEXT;
                        bgColor = LEVEL5_BGCOLOR;
                        fontColor = LEVEL5_FONTCOLOR;
                        break;
                    // 氾濫特別警報
                    case "F5":
                        text = LEVEL5_TEXT;
                        bgColor = LEVEL5_BGCOLOR;
                        fontColor = LEVEL5_FONTCOLOR;
                        break;
                    // 大雨特別警報
                    case "33":
                        text = LEVEL5_TEXT;
                        bgColor = LEVEL5_BGCOLOR;
                        fontColor = LEVEL5_FONTCOLOR;
                        break;
                    // 土砂特別警報
                    case "39":
                        text = LEVEL5_TEXT;
                        bgColor = LEVEL5_BGCOLOR;
                        fontColor = LEVEL5_FONTCOLOR;
                        break;
                    // 暴風特別警報
                    case "35":
                        text = LEVEL5_TEXT;
                        bgColor = LEVEL5_BGCOLOR;
                        fontColor = LEVEL5_FONTCOLOR;
                        break;
                    // 大雪特別警報
                    case "36":
                        text = LEVEL5_TEXT;
                        bgColor = LEVEL5_BGCOLOR;
                        fontColor = LEVEL5_FONTCOLOR;
                        break;
                    // 波浪特別警報
                    case "37":
                        text = LEVEL5_TEXT;
                        bgColor = LEVEL5_BGCOLOR;
                        fontColor = LEVEL5_FONTCOLOR;
                        break;
                    // 高潮特別警報
                    case "38":
                        text = LEVEL5_TEXT;
                        bgColor = LEVEL5_BGCOLOR;
                        fontColor = LEVEL5_FONTCOLOR;
                        break;
                    // 氾濫危険警報
                    case "F4":
                        text = LEVEL4_TEXT;
                        bgColor = LEVEL4_BGCOLOR;
                        fontColor = LEVEL4_FONTCOLOR;
                        break;
                    // 大雨危険警報
                    case "43":
                        text = LEVEL4_TEXT;
                        bgColor = LEVEL4_BGCOLOR;
                        fontColor = LEVEL4_FONTCOLOR;
                        break;
                    // 土砂危険警報
                    case "49":
                        text = LEVEL4_TEXT;
                        bgColor = LEVEL4_BGCOLOR;
                        fontColor = LEVEL4_FONTCOLOR;
                        break;
                    // 高潮危険警報
                    case "48":
                        text = LEVEL4_TEXT;
                        bgColor = LEVEL4_BGCOLOR;
                        fontColor = LEVEL4_FONTCOLOR;
                        break;
                }

                // 「解除」の場合
                if ("解除" === val) {
                    // テキスト
                    text = CANCEL_TEXT;
                    // 背景色
                    bgColor = CANCEL_BGCOLOR;
                    // 文字色
                    fontColor = CANCEL_FONTCOLOR;
                }

                // セル(TD)設定情報
                let tdInfo = {
                    cd: cd,
                    text: text,
                    bgColor: bgColor,
                    fontColor: fontColor,
                    newArrivalCss: newArrivalCss
                };

                return tdInfo;
            },

            showLayer: function () {
                // 指定したレイヤーを表示
                var layerQuery = Locator.getLayerQuery();
                // 51  気象警報注意報(固定レイヤー)
                layerQuery[51] = layerQuery[51] || '0';

                // URLに反映
                Locator.replaceState(QUERY.LAYER_LIST, Locator.toLayerQuery(layerQuery));
            }

            //showLegend: function() {}
        });
});
